import React from 'react';

const NotFound: React.FC = () => {
  return <p>The page is not found</p>;
};

export default NotFound;
